import { getAxiosClient } from "../../axios-client";
import {
  DeleteOfferPositionRequestBody,
  DeleteOfferPositionResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const deleteOfferPosition = async (
  body: DeleteOfferPositionRequestBody
) => {
  return await axiosClient.ax.delete<DeleteOfferPositionResponse>(
    "/Offers/DeleteOfferPossition",
    { data: body }
  );
};
